import React, { useState, useEffect } from "react";

const Gap = ({ size = 90 }) => {
  const [gapSize, setGapSize] = useState(size);

  useEffect(() => {
    const handleResize = () => {
      const screenWidth = window.innerWidth;

      if (screenWidth < 768) {
        // Mobile screens
        setGapSize(size * 0.1); // Reduce gap to 50% of the default size
      } else if (screenWidth < 1024) {
        // Tablet screens
        setGapSize(size * 0.5); // Reduce gap to 75% of the default size
      } else {
        // Large screens
        setGapSize(size); // Use the default size
      }
    };

    // Add event listener and set the initial gap size
    window.addEventListener("resize", handleResize);
    handleResize();

    // Cleanup event listener on component unmount
    return () => window.removeEventListener("resize", handleResize);
  }, [size]);

  return <div className="gap" style={{ height: `${gapSize}px` }} />;
};

export default Gap;
